module.exports = __webpack_public_path__ + "static/media/kotak.39690853.svg";